export enum NotificationChannel {
	Default = 'default',
	Push = 'push',
	AppToast = 'app-toast',
}
